// extracted by mini-css-extract-plugin
export var actionButton = "_bz-0";
export var attachmentLine = "_bz-1";
export var fileInput = "_bz-2";
export var fileUploadWrapper = "_bz-4";
export var footer = "_bz-3";
export var modalContent = "_bz-5";
export var paperclip = "_bz-6";
export var quillEditor = "_bz-7";